import Colors from 'assets/Colors';
import styled from 'styled-components';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 97%;
  margin: 0 auto;
`;

const TopContainer = styled.div`
padding-top: 17px;
padding-right: 22px;
padding-left: 22px;
width: 100%;
margin: 0 auto;
background: ${Colors.background_secondary};
border - radius: 2px;
 box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
max - width: 100vw;
 margin-bottom: 32px;
`;

export default {
  PageContainer,
  TopContainer,
};
